import { setLoadingConfigObject, shimmerPlaceholderConfig } from '../../Shimmer/Shimmer.utils';

const headerLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, {
      width: '100%',
      height: 20,
    }),
  },
];

export { headerLoadingConfig, shimmerPlaceholderConfig };
